import gql from 'graphql-tag';

const GET_SERVICE_CATALOG_ITEMS_FOR_TABLE = gql`
  query getServiceCatalogItems($listInfo: ListInfoInput!) {
    getServiceCatalogItems(listInfo: $listInfo) {
      items {
        itemId
        name
        description
        category {
          categoryId
          name
        }
        itemType
        offerAsWorklogItem
        status
        taxable
        salesTax {
          taxId
          name
        }
        sellingPrice {
          model
          details {
            value
            afterHoursValue
          }
        }
        costPrice {
          model
          details {
            value
            afterHoursValue
          }
        }
        integrationState {
          pax8
          xero
          quickbooks
        }
        serviceTypeItem {
          itemId
          offeringType
          defaultUsageType
          # bundledItems {
          #   name
          #   itemId
          #   itemType
          #   sellingPrice {
          #     model
          #     details {
          #       value
          #       afterHoursValue
          #     }
          #   }
          #   costPrice {
          #     model
          #     details {
          #       value
          #       afterHoursValue
          #     }
          #   }
          #   serviceTypeItem {
          #     itemId
          #     offeringType
          #     hourlyServiceTypeItem {
          #       itemId
          #       roundUpValue
          #       defaultItem
          #     }
          #     redeemableServiceBundle {
          #       itemId
          #       applicableType
          #       applicableHours
          #       redeemableQuantity
          #     }
          #   }
          # }
          hourlyServiceTypeItem {
            itemId
            roundUpValue
            defaultItem
          }
          redeemableServiceBundle {
            itemId
            applicableType
            applicableHours
            redeemableQuantity
          }
        }
      }
      listInfo {
        hasMore
        page
        pageSize
        totalCount
        sort {
          attribute
          order
        }
        condition
      }
    }
  }
`;

const GET_SERVICE_CATALOG_ITEMS_FOR_IT_TABLE = gql`
  query getServiceCatalogItems($listInfo: ListInfoInput!) {
    getServiceCatalogItems(listInfo: $listInfo) {
      items {
        itemId
        name
        description
        category {
          categoryId
          name
        }
        itemType
        offerAsWorklogItem
        status
        taxable
        salesTax {
          taxId
        }
        sellingPrice {
          model
          details {
            value
            afterHoursValue
          }
        }
        costPrice {
          model
          details {
            value
            afterHoursValue
          }
        }
        serviceTypeItem {
          itemId
          defaultUsageType
        }
      }
      listInfo {
        hasMore
        page
        pageSize
        totalCount
        sort {
          attribute
          order
        }
        condition
      }
    }
  }
`;

const GET_SERVICE_CATALOG_ITEMS = gql`
  query getServiceCatalogItems($listInfo: ListInfoInput!) {
    getServiceCatalogItems(listInfo: $listInfo) {
      items {
        itemId
        name
        description
        category {
          categoryId
          name
        }
        itemType
        offerAsWorklogItem
        status
        taxable
        salesTax {
          taxId
        }
        sellingPrice {
          model
          details {
            value
            afterHoursValue
          }
        }
        costPrice {
          model
          details {
            value
            afterHoursValue
          }
        }
        serviceTypeItem {
          itemId
          offeringType
          bundledItems {
            name
            itemId
            itemType
            sellingPrice {
              model
              details {
                value
                afterHoursValue
              }
            }
            costPrice {
              model
              details {
                value
                afterHoursValue
              }
            }
            serviceTypeItem {
              itemId
              offeringType
              hourlyServiceTypeItem {
                itemId
                roundUpValue
                defaultItem
              }
              redeemableServiceBundle {
                itemId
                applicableType
                applicableHours
                redeemableQuantity
              }
            }
          }
          hourlyServiceTypeItem {
            itemId
            roundUpValue
            defaultItem
          }
          redeemableServiceBundle {
            itemId
            applicableType
            applicableHours
            redeemableQuantity
          }
          defaultUsageType
        }
      }
      listInfo {
        hasMore
        page
        pageSize
        totalCount
        sort {
          attribute
          order
        }
        condition
      }
    }
  }
`;

const GET_SERVICE_CATALOG_ITEMS_FOR_RULE_BUILDER = gql`
  query getServiceCatalogItems($listInfo: ListInfoInput!) {
    getServiceCatalogItems(listInfo: $listInfo) {
      items {
        itemId
        name
      }
    }
  }
`;

const GET_SERVICE_CATALOG_ITEM = gql`
  query getServiceCatalogItem($input: ServiceCatalogItemIdentifierInput!) {
    getServiceCatalogItem(input: $input) {
      itemId
      name
      description
      category {
        categoryId
        name
      }
      itemType
      offerAsWorklogItem
      status
      taxable
      salesTax {
        taxId
      }
      sellingPrice {
        model
        details {
          value
          afterHoursValue
        }
      }
      costPrice {
        model
        details {
          value
          afterHoursValue
        }
      }
      integrationState {
        pax8
        xero
        quickbooks
      }
      serviceTypeItem {
        itemId
        offeringType
        defaultUsageType
        bundledItems {
          name
          itemId
          itemType
        }
        hourlyServiceTypeItem {
          itemId
          roundUpValue
        }
        redeemableServiceBundle {
          itemId
          applicableType
          applicableHours
          redeemableQuantity
        }
      }
    }
  }
`;

const GET_ELIGIBLE_SERVICE_ITEMS = gql`
  query getEligibleServiceCatalogItems(
    $input: GetEligibleCatalogServiceItemsInput!
  ) {
    getEligibleServiceCatalogItems(input: $input) {
      items {
        itemId
        name
        description
        category {
          categoryId
          name
        }
        itemType
        offerAsWorklogItem
        status
        taxable
        salesTax {
          taxId
          name
          rates {
            rateId
            name
            rateValue
          }
        }
        sellingPrice {
          model
          details {
            value
            afterHoursValue
          }
        }
        costPrice {
          model
          details {
            value
            afterHoursValue
          }
        }
        serviceTypeItem {
          itemId
          offeringType
          bundledItems {
            name
            itemId
            itemType
          }
          hourlyServiceTypeItem {
            itemId
            roundUpValue
            defaultItem
          }
          redeemableServiceBundle {
            itemId
            applicableType
            applicableHours
            redeemableQuantity
          }
        }
      }
      listInfo {
        hasMore
        page
        pageSize
        totalCount
        sort {
          attribute
          order
        }
        condition
      }
    }
  }
`;

export {
  GET_SERVICE_CATALOG_ITEMS,
  GET_SERVICE_CATALOG_ITEM,
  GET_ELIGIBLE_SERVICE_ITEMS,
  GET_SERVICE_CATALOG_ITEMS_FOR_TABLE,
  GET_SERVICE_CATALOG_ITEMS_FOR_IT_TABLE,
  GET_SERVICE_CATALOG_ITEMS_FOR_RULE_BUILDER
};
